import { SyberryTodayPlanStatus } from 'domain/people/syberryToday/types';

export enum SyberryTodayDashboardTab {
  DO_TODAY = 'doToday',
  ALL = 'all',
}

type SyberryTodayDashboardTabConfig = {
  id: SyberryTodayDashboardTab;
  label: string;
};

const DO_TODAY_TASKS_TAB: SyberryTodayDashboardTabConfig = {
  id: SyberryTodayDashboardTab.DO_TODAY,
  label: 'Do today tasks',
};

const ALL_TASKS_TAB: SyberryTodayDashboardTabConfig = {
  id: SyberryTodayDashboardTab.ALL,
  label: 'All tasks',
};

export const DASHBOARD_TABS = [DO_TODAY_TASKS_TAB, ALL_TASKS_TAB];

export const ALL_TASKS_ONLY_DASHBOARD_TABS = [ALL_TASKS_TAB];

export const ALL_TASKS_BY_DEFAULT_STATUSES = new Set<SyberryTodayPlanStatus>([
  SyberryTodayPlanStatus.POSTPONED,
  SyberryTodayPlanStatus.SKIPPED,
]);
